module.exports = __webpack_public_path__ + "img/IMG_1645_BlackMatted_MockedUp.4531c194.jpg";